import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  onActionEditar: (
    Id: number | null,
    openState: boolean,
    openAnalise: boolean,
  ) => void;
  onActionDeletar: (Id: number | null, openState: boolean) => void;
  onActionDownload: (Id: number | null) => void;
  read: boolean;
};

export const GenerateImagensColumns = ({
  onActionEditar,
  onActionDeletar,
  onActionDownload,
  read,
}: Props): GridColDef[] => {
  return [
    {
      field: "Ordem",
      filterable: false,
      headerName: "Ordem",
      minWidth: 90,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center text-center text-xs py-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Nome",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "DescricaoImagem",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-all w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "IdDiarioObrasImagens",
      sortable: false,
      filterable: false,
      headerName: "Ações",
      width: 140,
      minWidth: 140,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionDownload(params.value)}>
              <DynamicIcon
                nameIcon="Download"
                size={25}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            {read === false && (
              <>
                <IconButton
                  onClick={() => onActionEditar(params.value, true, false)}
                >
                  <DynamicIcon
                    nameIcon="EditRounded"
                    size={25}
                    className="dark:text-white text-primary-green"
                  />
                </IconButton>

                <IconButton onClick={() => onActionDeletar(params.value, true)}>
                  <DynamicIcon
                    nameIcon="DeleteForeverRounded"
                    size={25}
                    className="text-red-500"
                  />
                </IconButton>
              </>
            )}
          </div>
        );
      },
    },
  ];
};
